import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.6051 13.6043L18.75 18.75M15.8108 8.27996C15.8108 12.4386 12.4394 15.8099 8.28042 15.8099C4.12148 15.8099 0.75 12.4386 0.75 8.27996C0.75 4.12128 4.12148 0.75 8.28042 0.75C12.4394 0.75 15.8108 4.12128 15.8108 8.27996Z",
		stroke: "#666666",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSearch;
